import React, { useState } from "react";
import { Icon } from "@iconify/react";

import { TableContainer } from "@mui/material";
// import { thStyle, tdStyle, inputStyle } from '../../../support/addstock/tableStyles';
// import { thStyle, tdStyle, inputStyle } from "../addstock/tableStyles";
import { Button, Typography, TextField } from "@mui/material";
import style from "./ListTable.module.css";

export default function LIstTable({
  columns,
  data,
  allCategories,
  handleEditData,
  title,
  searchInput,
  setSearchInput,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedDate, setSelectedDate] = useState("");

  const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1);

  console.log(data);

  return (
    <>
      <div className={style["table-container"]}>
        <table className={style["custom-table"]}>
          <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={{
                    padding: "8px",
                    border: "1px solid #ccc",
                    textAlign: "center",
                    backgroundColor: "#627383",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: "600",
                    minWidth: "fit-content",
                  }}
                >
                  {column.label}
                </th>
              ))}
              <th
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  right: 0,
                  background: "#627282",
                  zIndex: 1,
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((product, idx) => (
              <tr
                key={product?.Id}
                className={`${style.tableRow} ${
                  idx % 2 === 0 ? style.evenRow : style.oddRow
                }`}
              >
                {columns?.map((column) => (
                  <td
                    style={{ fontSize: "12px" }}
                    key={column?.key}
                    className={style.tableCell}
                  >
                    {/* {column.key === "serialNumber" ? (
              idx + 1 + (currentPage - 1) * rowsPerPages
            ) : (
              column.type === "read" &&
              (column.calculate ? column.calculate(product) : product[column.key])
            )} */}
                    {product[column.key]}
                  </td>
                ))}
                <td
          style={{
            fontSize: "12px",
            position: "sticky",
            right: -9,
            zIndex: 1,
          }}
        >
          <div className={style["action-container"]}>
            <Icon
              onClick={() => handleEditData(product)}
              style={{ color: "#627282", cursor: "pointer" }}
              icon="material-symbols-light:edit-outline"
              width="20"
              height="20"
            />
            {/* <Icon
              style={{ color: "#627282", cursor: "pointer" }}
              icon="weui:delete-filled"
              width="20"
              height="20"
            />
            <Icon
              style={{ color: "#627282", cursor: "pointer" }}
              icon="ic:outline-print"
              width="20"
              height="20"
            /> */}
          </div>
        </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* <div className={style["page-controls"]}>
    <div className={style["pagination"]}>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <div
          key={page}
          className={
            currentPage === page
              ? style["pagination-pages-active"]
              : style["pagination-pages"]
          }
          onClick={() => handlePageClick(page)}
        >
          {page}
        </div>
      ))}
    </div>

    <div className={style["rows-per-page"]}>
      <label htmlFor="rows-per-page">Rows per page</label>
      <select
        id="rows-per-page"
        value={rowsPerPages}
        onChange={handleRowsPerPageChange}
      >
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
    </div>
  </div> */}
    </>
  );
}
